import { useLoaderData, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { checkExpiry, getUserId } from "../services/helpers";
import mixpanel from "../services/mixpanel";
import { useEffect, useState } from "react";
import { Button } from "../components/Button";
import { TextField } from "../components/TextField";
import { sendExpiryNotification } from "../services/api";


export default function  RoadworthyAndLicensePage(){
	const loaderData = useLoaderData();
	const cars = loaderData.data.vehicles;

	// const todayDate = new Date()
	const [showNotificationDialog, setShowNotificationDialog] = useState(false);
	const [selectedVehicle, setSelectedVehicle] = useState(null);
	const [isSending, setIsSending] = useState(false);
	const [customerName, setCustomerName] = useState('');
	const [customerEmail, setCustomerEmail] = useState('');
	const [searchFilter, setSearchFilter] = useState('');
	const [showOnlyWithDates, setShowOnlyWithDates] = useState(true);
	const [sortBy, setSortBy] = useState(null);
	const [sortOrder, setSortOrder] = useState('asc');
	const navigate = useNavigate();


	let filteredCars = cars.filter((car) =>
		(`${car.customer_name}`.toLowerCase().includes(searchFilter.trim().toLowerCase())
		|| car.license_plate?.toLowerCase().includes(searchFilter.trim().toLowerCase())
		|| car.vehicle_name?.toLowerCase().includes(searchFilter.trim().toLowerCase()))
		&& (!showOnlyWithDates || (car.insurance_expiry || car.roadworthy_expiry))
	);

	if (sortBy) {
		filteredCars.sort((a, b) => {
			let aValue = sortBy === 'insurance' ? a.insurance_expiry : a.roadworthy_expiry;
			let bValue = sortBy === 'insurance' ? b.insurance_expiry : b.roadworthy_expiry;

			if (!aValue) return 1;
			if (!bValue) return -1;

			const comparison = new Date(aValue) - new Date(bValue);
			return sortOrder === 'asc' ? comparison : -comparison;
		});
	}


	useEffect(()=>{
		mixpanel.identify(getUserId());
	},[]);

	async function sendNotification() {
		setIsSending(true);
		try {
			const notificationData = {
				customer_name: customerName,
				customer_email: customerEmail,
				vehicle_name: selectedVehicle.vehicle_name,
				license_plate: selectedVehicle.license_plate,
				insurance_expiry_date: selectedVehicle.insurance_expiry,
				roadworthy_expiry_date: selectedVehicle.roadworthy_expiry
			};

			const response = await sendExpiryNotification(notificationData);

			if (response) {
				alert('Notification sent successfully!');
				setShowNotificationDialog(false);
				setSelectedVehicle(null);
				setCustomerName('');
				setCustomerEmail('');
			} else {
				alert('Failed to send notification');
			}
		} catch (error) {
			console.error('Error sending notification:', error);
			alert('Error sending notification');
		} finally {
			setIsSending(false);
		}
	}

	function handleNotifyClick(vehicle) {
		setSelectedVehicle(vehicle);
		setCustomerName(vehicle.customer_name);
		setCustomerEmail(vehicle.email); // Will need to be populated from API or left empty for user input
		setShowNotificationDialog(true);
	}

	function handleSort(column) {
		if (sortBy === column) {
			setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
		} else {
			setSortBy(column);
			setSortOrder('asc');
		}
	}


	return (<main>
		<h1>Road worthy and License Expiry</h1>
		<div className="row" id="page-actions">
			<TextField
				hint="Name, License Plate or Vehicle"
				value={searchFilter}
				onChange={(value)=>{setSearchFilter(value.target.value);}}
			/>
			<div className="row" style={{ "gap": "5px" }}>
				<Link onClick={(event)=>{event.preventDefault(); setShowOnlyWithDates(false);}}>All Vehicles</Link>
				<Link onClick={(event)=>{event.preventDefault(); setShowOnlyWithDates(true);}}>With Expiry Dates</Link>
			</div>
		</div>
		<table>
			<thead>
						<tr>
							<th>Customer</th>
							<th>Vehicle</th>
							<th
								style={{ cursor: 'pointer' }}
								onClick={() => handleSort('insurance')}
							>
								Roadworthy Expiry {sortBy === 'insurance' && (sortOrder === 'asc' ? '↑' : '↓')}
							</th>
							<th
								style={{ cursor: 'pointer' }}
								onClick={() => handleSort('roadworthy')}
							>
								License Expiry {sortBy === 'roadworthy' && (sortOrder === 'asc' ? '↑' : '↓')}
							</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						{filteredCars.map((car) => (
							<tr key={car.vehicle_id}>
								<td
									className="clickable"
									onClick={()=>navigate(`/dashboard/members/u/${car.customer_id}/vehicles`)}
								>
								{car.customer_name}</td>
								<td
									className="clickable"
									onClick={()=>navigate(`/dashboard/vehicles/${car.license_plate}/services`)}
								>{`${car.vehicle_name} (${car.license_plate})`}</td>
								<td className={`${checkExpiry(car.insurance_expiry) && "red-text"}`}>{car.insurance_expiry ?? "n/a"}</td>
								<td className={`${checkExpiry(car.roadworthy_expiry) && "red-text"}`}>{car.roadworthy_expiry ?? "n/a"}</td>
								<td>
									<Link to={`/dashboard/vehicles/${car.license_plate}/services`}>View Vehicle</Link>
									{(checkExpiry(car.insurance_expiry) || checkExpiry(car.roadworthy_expiry)) && (
										<>
											<span> | </span>
											<Link
												to="#"
												onClick={(e) => {
													e.preventDefault();
													handleNotifyClick(car);
												}}
												style={{ color: '#1976d2', cursor: 'pointer' }}
											>
												Notify
											</Link>
										</>
									)}
								</td>
							</tr>
						))}
					</tbody>
		</table>

		{showNotificationDialog && selectedVehicle && (
			<div className="dialog-overlay">
				<div className="dialog">
					<div className="dialog-header">
						<h3>Send Expiry Notification</h3>
					</div>
					<div className="dialog-content">
						<p>Send expiry notification for vehicle <strong>{selectedVehicle.vehicle_name} ({selectedVehicle.license_plate})</strong></p>
						<div style={{ marginTop: '15px' }}>
							<div className="row">
								<div className="col">
									<TextField
										label="Customer Name"
										type="text"
										value={customerName}
										onChange={(e) => setCustomerName(e.target.value)}
									/>
								</div>
							</div>
							<div className="row" style={{ marginTop: '10px' }}>
								<div className="col">
									<TextField
										label="Customer Email"
										type="email"
										value={customerEmail}
										onChange={(e) => setCustomerEmail(e.target.value)}
									/>
								</div>
							</div>
							<div style={{ marginTop: '15px' }}>
								{selectedVehicle.insurance_expiry && checkExpiry(selectedVehicle.insurance_expiry) && (
									<p>• Insurance expires: {selectedVehicle.insurance_expiry}</p>
								)}
								{selectedVehicle.roadworthy_expiry && checkExpiry(selectedVehicle.roadworthy_expiry) && (
									<p>• Roadworthy expires: {selectedVehicle.roadworthy_expiry}</p>
								)}
							</div>
						</div>
					</div>
					<div className="dialog-footer">
						<Button
							onClick={() => {
								setShowNotificationDialog(false);
								setSelectedVehicle(null);
								setCustomerName('');
								setCustomerEmail('');
							}}
							color="red"
							label="Cancel"
						/>
						<Button
							onClick={sendNotification}
							color="green"
							label={isSending ? "Sending..." : "Send Notification"}
							disabled={isSending}
						/>
					</div>
				</div>
			</div>
		)}
	</main>)
}